import Vue from 'vue'

const API_URL =
  process.env.API_URL ||
  window.location.protocol + '//' + window.location.hostname + ':3005'

Vue.prototype.$global = {
  apiUrl: API_URL
}
